import { useState } from 'react'
import { api, ErroreApi } from '../servizi/api.ts'
import { useSessione } from '../servizi/sessione.tsx'
import { Bottone, Modale } from './base.tsx'

/**
 * Palestra personale (decisione di Davide del 31/10/2026, migrazione 490).
 *
 * L'interruttore sta nella testata, accanto al nome e a «Esci»; a palestra accesa una fascia
 * colorata resta in vista su ogni pagina, con il comando per uscire. Lo stato e' della sessione,
 * lato server: qui si chiede solo di cambiarlo.
 *
 * Accesa o spenta, la pagina si ricarica da capo. Sedi, cataloghi e permessi si leggono una volta
 * dopo l'accesso (servizi/sessione.tsx), e in palestra cambiano tutti: una pagina che restasse con
 * le tendine dei dati veri proporrebbe sedi che in palestra non si possono scegliere.
 */
async function cambia(accesa: boolean, errore: (m: string) => void) {
  try {
    await api.post('/palestra', { accesa })
    window.location.assign('/')
  } catch (e) {
    errore(e instanceof ErroreApi ? e.message : 'Non è andata a buon fine: controlla la connessione e riprova.')
  }
}

/** Il comando nella testata. Non compare a chi non ha niente da provare (gli utenti di prova). */
export function InterruttorePalestra() {
  const { io } = useSessione()
  const [inCorso, setInCorso] = useState(false)
  const [errore, setErrore] = useState<string | null>(null)
  if (!io?.palestra?.disponibile) return null
  const accesa = io.palestra.accesa
  return (
    <>
      <Bottone variante={accesa ? 'primario' : 'discreto'} dimensione="piccolo" aria-pressed={accesa}
               inCorso={inCorso}
               title={accesa ? 'Esci dalla palestra e torna ai dati veri'
                 : 'Prova il gestionale con i tuoi ruoli sulle schede inventate della sede di formazione'}
               onClick={() => { setInCorso(true); void cambia(!accesa, (m) => { setInCorso(false); setErrore(m) }) }}>
        Palestra
      </Bottone>
      {errore && (
        <Modale titolo="Palestra" chiudi={() => setErrore(null)}
                azioni={<Bottone variante="primario" onClick={() => setErrore(null)}>Chiudi</Bottone>}>
          <p>{errore}</p>
        </Modale>
      )}
    </>
  )
}

/** La fascia della palestra accesa, sotto la testata. */
export function NastroPalestra() {
  const { io } = useSessione()
  const [inCorso, setInCorso] = useState(false)
  const [errore, setErrore] = useState<string | null>(null)
  if (!io?.palestra?.accesa) return null
  return (
    <div className="palestra-nastro" role="status">
      <span className="palestra-segno" aria-hidden="true" />
      <span className="palestra-testo">
        <strong>Sei in palestra:</strong> dati inventati della sede di formazione.
        {errore && <span className="palestra-errore"> {errore}</span>}
      </span>
      <span className="spinta">
        <Bottone variante="secondario" dimensione="piccolo" inCorso={inCorso}
                 onClick={() => { setInCorso(true); void cambia(false, (m) => { setInCorso(false); setErrore(m) }) }}>
          Esci dalla palestra
        </Bottone>
      </span>
    </div>
  )
}
